import {Box, Button, Chip, Divider, FormControl, Icon, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography} from "@mui/material";
import {ClientDto, ClientService, UserDetailDto, UserService} from "../../api/psc.ts";
import {useContext, useEffect, useState} from "react";
import DialogContainer from "../../components/DialogContainer";
import DialogHeader from "../../components/DialogHeader";
import Spinner from "../../components/Spinner";
import {DialogContext} from "../../contexts/DialogueContext";

export default function UserAccessDialog(props: { user: UserDetailDto }) {

    const [clients, setClients] = useState<ClientDto[] | null>(null)
    const [selectedClaims, setSelectedClaims] = useState<number[]>(props.user.claims.map(cc => cc.clientClaimId))
    const [requestInProgress, setRequestInProgress] = useState(false)

    const {closeDialog} = useContext(DialogContext)

    useEffect(() => {
        fetch()
    }, [])

    const fetch = () => {
        ClientService.listClients().then(r => {
            setClients(r)
        })
    }

    const updateAccess = () => {
        setRequestInProgress(true)
        UserService.updateUserClaims(props.user.id, {claimIds: selectedClaims})
            .then(r => {
                setRequestInProgress(false)
                closeDialog()
            })
            .finally(() => {
                setRequestInProgress(false)
            })
    }

    const toggleClaimId = (claimId: number) => {
        if (selectedClaims.includes(claimId)) {
            setSelectedClaims([...selectedClaims.filter(cid => cid !== claimId)])
        }else{
            setSelectedClaims([...selectedClaims, claimId])
        }
    }

    if (clients === null) {
        return <Spinner/>
    }

    return <DialogContainer>

        <DialogHeader title='دسترسی های کاربر'/>

        <Stack spacing={2} sx={{p: 2}}>

            {
                clients.map(c => {
                    return <Stack spacing={1.5}>

                        <Divider textAlign='left'>
                            <Typography color='text.secondary'>
                                {c.displayName}
                            </Typography>
                        </Divider>

                        <Stack direction='row' gap={1} flexWrap='wrap'>
                            {
                                c.claims.map(cc => {
                                    const isSelected = selectedClaims.includes(cc.id)
                                    return <Chip onClick={() => toggleClaimId(cc.id)}
                                                 color={isSelected ? 'success' : 'default'}
                                                 label={cc.displayName}
                                                 icon={isSelected ? <Icon>done</Icon> : <Icon>add</Icon>}/>
                                })
                            }
                        </Stack>

                    </Stack>
                })
            }


            <Button disabled={requestInProgress} fullWidth variant='contained' onClick={updateAccess}>
                به روز رسانی دسترسی
            </Button>

        </Stack>
    </DialogContainer>
}
